<div class="ha-personal-info-section section-wrapper" id="general-personal-info">
	<div class="heading">
		<span [translate]="'wellness.health-assessment-new.general-information.personal-information.heading'">
			Personal Information
		</span>
	</div>
	<div class="profile-info">
		<div class="w-50">
			<div>{{ personalInfo?.firstName }} {{ personalInfo?.lastName }}</div>
			<div>{{ personalInfo?.dateOfBirth }}</div>
		</div>
		<div class="w-50">
			<div *ngIf="personalInfo?.address?.addressLine1">{{ personalInfo?.address?.addressLine1 }},</div>
			<div *ngIf="personalInfo?.address?.addressLine2">{{ personalInfo?.address?.addressLine2 }},</div>
			<div>{{ personalInfo?.address?.city }},</div>
			<div>{{ personalInfo?.address?.state }} {{ personalInfo?.address?.zip }}</div>
		</div>
	</div>
	<div class="form-group" [formGroup]="personalInfoForm">
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.home-phone'
						">
						Home Phone
					</span>
				</mat-label>
				<input matInput formControlName="homePhone" [imask]="phoneMask.iMaskArgs" appAutofocus [readonly]="readOnly" />
				<mat-error>
					<app-error-message [control]="'homePhone'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.cell-phone'
						">
						Cell Phone
					</span>
				</mat-label>
				<input matInput formControlName="cellPhone" [imask]="phoneMask.iMaskArgs" [readonly]="readOnly" />
				<mat-error>
					<app-error-message [control]="'cellPhone'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.preferred-email'
						">
						Preferred Email
					</span>
				</mat-label>
				<input matInput formControlName="preferredEmail" [readonly]="readOnly" />
				<mat-error>
					<app-error-message [control]="'preferredEmail'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.ethnic-background'
						">
						Ethnic Background
					</span>
				</mat-label>
				<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="ethnicBackgroundID">
					<mat-option *ngFor="let ethinicity of ethnicBackgroundData" [value]="ethinicity.id">
						{{ ethinicity.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.marital-status'
						">
						Marital Status
					</span>
				</mat-label>
				<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="maritalStatusID">
					<mat-option *ngFor="let status of maritalStatusLookupData" [value]="status.id">{{ status.name }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.education-level'
						">
						Education Level
					</span>
				</mat-label>
				<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="educationID">
					<mat-option *ngFor="let educationLevel of educationLookupData" [value]="educationLevel.id">{{
						educationLevel.name
					}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.gender-identity'
						">
						Gender Identity
					</span>
				</mat-label>
				<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="genderIdentityID">
					<mat-option *ngFor="let gender of genderIdentityLookup" [value]="gender.id">{{ gender.name }}</mat-option>
				</mat-select>
				<mat-error>
					<app-error-message [control]="'genderIdentityID'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill" floatLabel="always">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.preferred-title'
						">
						Preferred Title
					</span>
				</mat-label>
				<mat-select
					disableOptionCentering
					panelClass="custom-material-position"
					formControlName="preferredTitleID"
					placeholder="Select">
					<mat-option *ngFor="let title of preferredTitleLookup" [value]="title.id">{{ title.name }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill" floatLabel="always">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.personal-information.form-fields.preferred-pronouns'
						">
						Preferred Pronoun
					</span>
				</mat-label>
				<mat-select
					disableOptionCentering
					panelClass="custom-material-position"
					formControlName="preferredPronounsID"
					placeholder="Select">
					<mat-option *ngFor="let pronoun of preferredPronounsLookup" [value]="pronoun.id">
						{{ pronoun.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
	<div class="heading" id="general-emergency">
		<span [translate]="'wellness.health-assessment-new.general-information.emergency-contact.heading'"
			>Emergency Contact</span
		>
	</div>
	<div [formGroup]="emergencyContactForm">
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="'wellness.health-assessment-new.general-information.emergency-contact.form-fields.full-name'">
						Full Name
					</span>
				</mat-label>
				<input matInput formControlName="fullName" [readonly]="readOnly" />
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span [translate]="'wellness.health-assessment-new.general-information.emergency-contact.form-fields.phone'">
						Phone
					</span>
				</mat-label>
				<input matInput formControlName="phone" [imask]="phoneMask.iMaskArgs" [readonly]="readOnly" />
				<mat-error>
					<app-error-message [control]="'phone'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="form-field">
			<mat-form-field appearance="fill">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.general-information.emergency-contact.form-fields.relationship'
						">
						Relationship
					</span>
				</mat-label>
				<input matInput formControlName="relationship" [readonly]="readOnly" />
			</mat-form-field>
		</div>
	</div>
	<div class="heading" id="general-livingwill">
		<span [translate]="'wellness.health-assessment-new.general-information.living-will.heading'">Living Will</span>
	</div>
	<div [formGroup]="livingWillForm">
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.have-living-will'">
			Do you have an advance directive or living will?
		</div>
		<fieldset>
			<mat-radio-group formControlName="haveLivingWill">
				<mat-radio-button [value]="true">
					<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-yes'">
						Yes
					</span>
				</mat-radio-button>
				<mat-radio-button [value]="false">
					<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-no'">
						No
					</span>
				</mat-radio-button>
			</mat-radio-group>
		</fieldset>
		<ng-container *ngIf="livingWillForm.get('haveLivingWill').value === false">
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.discuss-option'">
				Is this something you would like to discuss?
			</div>
			<fieldset>
				<mat-radio-group formControlName="discussOption">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-yes'">
							Yes
						</span>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-no'">
							No
						</span>
					</mat-radio-button>
				</mat-radio-group>
			</fieldset>
		</ng-container>
	</div>
</div>

<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button
		class="button button-medium"
		mat-button
		appEheAnalytics
		[data]="{
			pageUrl: '/ha/new/(general:personal-info)',
			redirectedTo: '/ha/new/(general:primary-care)',
			componentName: 'PersonalInfo',
			id: 'HA General Info - Personal Info',
			placement: 'ha personal info screen'
		}">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
